import React, { FC } from 'react';
import { StyledMessagesContainer, StyledMessagesPositioner } from './WarningMessages.styles';
import MessageList from './MessageList';
import { WarningMessage } from '../../../interfaces/WarningMessage';

export interface WarningMessagesProps {
  messages: WarningMessage[];
}

const WarningMessages: FC<WarningMessagesProps> = ({ messages, ...props }) => {
  if ((messages?.length ?? 0) === 0) return null;

  return (
    <StyledMessagesContainer {...props}>
      <StyledMessagesPositioner>
        <MessageList messages={messages} />
      </StyledMessagesPositioner>
    </StyledMessagesContainer>
  );
};
export default WarningMessages;
